import React from "react";
import styles from "./about.module.css";
import "antd/dist/reset.css";
import { MentorPhotos } from "./mentor-photos";

export const SectionAbout = () => {

  return (
    <>
      <section className={styles.sectionAboutContainer} id="about">
        <div className={styles.sectionAboutWrap}>

          <div className={styles.sectionAboutInfo}>
            <article className={styles.infoPanel}>
              <div className={styles.cardScanline} aria-hidden="true" />
              <div className={styles.cardCornerTL} aria-hidden="true" />
              <div className={styles.cardCornerBR} aria-hidden="true" />

              <h2 className={styles.sectionAboutInfoTitle}>Кто ведёт</h2>
              <p className={styles.sectionAboutInfoSubtitle}>
                <span className={styles.sectionAboutInfoName}>
                  Мария Бурлакова
                </span>
              </p>
              <p className={styles.sectionAboutInfoText}>
                Руководитель команды разработки в бигтехе, внутренний и внешний <a href="/mentor">ментор </a>,
                веду корпоративный и внешний книжный клуб. Драйвит в этом не деньги, не статус, а
                удовольствие от понимания того, как устроен мир. И удовольствие от
                поиска и нахождения более эффективных способов что-то делать и
                переосбирать модели мышления в новом мире.
              </p>
              <p className={styles.sectionAboutInfoText}>
                Моя любовь уже десять лет – теория драматургии. Люблю смотреть и видеть, как строятся и чувствуются истории развития
                любой системы – персонажа, жанра, культуры.
              </p>
              <p className={styles.sectionAboutInfoText}>
                За годы выработан специфический скилл — могу рассказать, о чём
                произведение по:
              </p>
              <ul className={styles.skillList}>
                <li>абзацу из книги или даже по названию</li>
                <li>отрывку из песни, даже без слов</li>
                <li>постеру фильма или даже по рандомному стопкадру</li>
              </ul> 
            </article>

            <div className={styles.sectionAboutInfoBadges}>
              <div className={`${styles.sectionAboutInfoBadge} ${styles.badgeMindLove}`}>
                <div className={styles.cardScanline} aria-hidden="true" />
                <div className={styles.cardCornerTL} aria-hidden="true" />
                <div className={styles.cardCornerBR} aria-hidden="true" />
                <div className={`${styles.sectionAboutInfoBadgeIcon} ${styles.sectionAboutInfoBadgeIconMindLove}`}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                    <path d="m9 11 2 2 4-4"></path>
                  </svg>
                </div>
                <div className={styles.badgeInfo}>
                  <h4>Любовь к разуму</h4>
                  <p className={styles.sectionAboutInfoBadgeText}>
                    Тотальное уважение к иным умам и мнениям. Без условий, без оценки, без интеллектуального взгляда свысока.
                  </p>
                </div>
              </div>
              <div className={`${styles.sectionAboutInfoBadge} ${styles.badgeSpeed}`}>
                <div className={styles.cardScanline} aria-hidden="true" />
                <div className={styles.cardCornerTL} aria-hidden="true" />
                <div className={styles.cardCornerBR} aria-hidden="true" />
                <div className={`${styles.sectionAboutInfoBadgeIcon} ${styles.sectionAboutInfoBadgeIconSpeed }`}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                  </svg>
                </div>
                <div className={styles.badgeInfo}>
                  <h4>Скорость & Качество</h4>
                  <p className={styles.sectionAboutInfoBadgeText}>
                    Разбор готов за неделю. Каждая встреча уникальна и строится от вопросов, интересующих группу.
                  </p>
                </div>
              </div>
              <div className={`${styles.sectionAboutInfoBadge} ${styles.badgeGreen}`}>
                <div className={styles.cardScanline} aria-hidden="true" />
                <div className={styles.cardCornerTL} aria-hidden="true" />
                <div className={styles.cardCornerBR} aria-hidden="true" />
                <div className={`${styles.sectionAboutInfoBadgeIcon} ${styles.sectionAboutInfoBadgeIconGreen}`}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </div>
                <div className={styles.badgeInfo}>
                  <h4>Упорство</h4>
                  <p className={styles.sectionAboutInfoBadgeText}>
                    12 раз прочитана Гарри Поттер и Методы рационального мышления. Я умею находить новое в старом.
                  </p>
                </div>
              </div>
              <div className={`${styles.sectionAboutInfoBadge} ${styles.badgeExperience}`}>
                <div className={styles.cardScanline} aria-hidden="true" />
                <div className={styles.cardCornerTL} aria-hidden="true" />
                <div className={styles.cardCornerBR} aria-hidden="true" />
                <div className={`${styles.sectionAboutInfoBadgeIcon} ${styles.sectionAboutInfoBadgeIconExperience}`}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 3v18h18"></path>
                    <path d="m19 9-5 5-4-4-3 3"></path>
                  </svg>
                </div>
                <div className={styles.badgeInfo}>
                  <h4>Годы в крупной компании</h4>
                  <p className={styles.sectionAboutInfoBadgeText}>
                    Знаю боли всех уровней и слоёв из корпоративной жизни. Повидала.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.photosCard}>
            <div className={styles.cardScanline} aria-hidden="true" />
            <div className={styles.cardCornerTL} aria-hidden="true" />
            <div className={styles.cardCornerBR} aria-hidden="true" />
            <MentorPhotos />
          </div>
        </div>
      </section>
    </>
  );
};
